import {
  REMOVE_SYSTEM_USER_REQUEST,
  REMOVE_SYSTEM_USER_SUCCESS,
  REMOVE_SYSTEM_USER_FAILURE,
  REMOVE_SYSTEM_USER_RESET,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: '',
};

const removeSystemUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_SYSTEM_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: '',
      };

    case REMOVE_SYSTEM_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || 'User removed successfully',
      };

    case REMOVE_SYSTEM_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Something went wrong',
        success: false,
        message: '',
      };

    case REMOVE_SYSTEM_USER_RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export default removeSystemUserReducer;
